import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "c-input-date__wrap" }
const _hoisted_2 = { class: "c-input-date__icon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_IconCalendar = _resolveComponent("IconCalendar")!
  const _component_IconBase = _resolveComponent("IconBase")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_DatePicker, {
      value: _ctx.initValue,
      "min-date": _ctx.minDate,
      "max-date": _ctx.maxDate,
      masks: _ctx.masksOptions,
      theme: _ctx.themesOptions,
      popover: _ctx.popoverOptions,
      "is-inline": false,
      "input-props": {
        id: _ctx.name,
        name: _ctx.name,
        class: _ctx.inputClass,
        autocomplete: false,
        placeholder: _ctx.isIe ? '' : _ctx.placeholder,
        readonly: false,
        autocomplete: 'off'
      },
      onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateValue($event)))
    }, null, 8, ["value", "min-date", "max-date", "masks", "theme", "popover", "input-props"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_IconBase, {
        "view-box": "0 0 16 16",
        width: "16",
        height: "16"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_IconCalendar)
        ]),
        _: 1
      })
    ])
  ]))
}